import styled, { css } from 'styled-components';
import * as C from '../../loggedout/shared-styles/Colors';
import FontGraphie from '../../loggedout/shared-styles/graphieFont';
import { device } from '../../../utils/responsive_utilities';

export const InputWrapper = styled.form`
  position: relative;
  width: ${props => props.adjustWithContainer ? '100%' : '44rem'};
  height: ${props => props.adjustWithContainerHeight? '100%' : ''};
  display: inline-flex;
  @media ${device.Phone} {
    width: ${props => props.adjustWithContainer ? '100%' : '34.3rem'};
  }
  @media ${device.PhoneTabletLandscape} {
    width: ${props => props.adjustWithContainer ? '100%' : '27.8rem'};
  }
`;

export const Label = styled.label`
  position: absolute;
  background: ${C.deepCoveDark};
  color:  ${props => props.isError ? C.orange : props.validInputField ? C.Downy : C.VividViolet};
  left: 2.4rem;
  top: 0;
  ${FontGraphie(1.6, 1.2, 5)}
  padding: 0 0.5rem;
  opacity: 0;
  transition: all 0.3s ease-in;
  @media ${device.Phone} {
    left: 2rem;
    ${FontGraphie(1.2, 1.33, 5)}
  }
  @media ${device.PhoneTabletLandscape} {
    left: 2rem;
    ${FontGraphie(1, 2, 5)}
  }
`;

export const HelperMessage = styled.span`
  position: absolute;
  color: #8535A9;
  ${FontGraphie(1.6, 1.2, 5)}
  top: 118%;
  left: 2.3rem;
  opacity: 0;
  transition: all 0.3s ease-in;
  @media ${device.Phone} {
    ${FontGraphie(1.2, 1.2, 5)}
  }
  @media ${device.PhoneTabletLandscape} {
    ${FontGraphie(1, 1.2, 5)}
  }
`;

export const TextField = styled.input`
  display: block;
  width: ${props => props.adjustWithContainer ? '100%' : '44rem'};
  min-height: ${props => props.adjustWithContainerHeight? '100%' : '5.6rem'};
  border-radius: 3.2rem;
  border: 0.1rem solid ${props => props.success ? C.Downy : '#9D9FFC'};
  ${FontGraphie(2, 1.4, 6)}
  text-indent: 2.3rem;
  color: ${props => props.success ? C.Downy : C.indigo};
  background-color: transparent;
  outline: 0;
  padding: 0 0.8rem;
  &::placeholder {
    color: ${C.indigo};
  }
  &:focus {
    border: 0.1rem solid ${props => props.isError ? C.orange : props.validInputField? C.Downy : C.lightPurple};
    color: ${props => props.inputTextColor? props.inputTextColor : C.lightPurple};
  }
  &:focus ~ ${Label} {
    opacity: 1;
    top: -0.9rem;
  }
  &:focus ~ ${HelperMessage} {
    opacity: 1
  }
  @media ${device.Phone} {
    min-height: ${props => props.adjustWithContainerHeight? '100%' : '5.4rem'};
    ${FontGraphie(1.6, 1.4, 6)}
  }
  @media ${device.PhoneTabletLandscape} {
    min-height: ${props => props.adjustWithContainerHeight? '100%' : '3.4rem'};
    ${FontGraphie(1.4, 1.4, 6)}
  }
`;

export const Icon = styled.span`
  width: 7.1rem;
  height: 5.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => {
    if (props.success) return C.Downy;
    else if (props.notEmpty) return C.white;
    else return C.royal;
  }};
  border-radius: 2.8rem;
  position: absolute;
  right: 0.1rem;
  top: 50%;
  transform: translateY(-50%);
  transition: all ${props => props.success ? '0.5s' : '0.1s'} ease-in;
  ${(props) => props.notEmpty ? 
    css` 
      cursor: pointer;
    ` :
    css` 
      cursor: default;
    `
  }
  &:focus ~ ${Label} {
    opacity: 1;
    top: -0.9rem;
  }
  > i {
    color: ${props => props.notEmpty ? C.royal : C.white};
    font-size: 1.8rem;
    transform: rotate(180deg);
  }
  @media ${device.Phone} {
    width: 6.7rem;
    height: 5.4rem;
    > i {
      font-size: 2rem;
    }
  }
  @media ${device.PhoneTabletLandscape} {
    width: 4.2rem;
    height: 3.4rem;
    > i {
      font-size: 1.2rem;
    }
  }
`;